import webmvc from '../img/DeveloperTools/mvcicon.jpg';
import csharp from '../img/DeveloperTools/csharpicon.PNG';
import ajaxhtml from '../img/DeveloperTools/ajaxhtmlicon.jpg';
import javascript from '../img/DeveloperTools/javascripticon.jpg';
import nodejs from '../img/DeveloperTools/nodejsicon.jpg';
import reactjs from '../img/DeveloperTools/reacticon.PNG';
import android from '../img/DeveloperTools/Androidicon.jpg';
import oracle from '../img/DeveloperTools/oracleicon.jpg';
import postgres from '../img/DeveloperTools/postgresqlicon.jpg';
import mongodb from '../img/DeveloperTools/mongodbicon.PNG';
import mysql from '../img/DeveloperTools/mysqlicon.PNG';
import sqlserver from '../img/DeveloperTools/sqlservericon.PNG';

const ToolGroups = [
    { Src: webmvc, Alt: "Web MVC" },
    { Src: csharp, Alt: "C Sharp" },
    { Src: ajaxhtml, Alt: "Ajax Html" },
    { Src: javascript, Alt: "JavaScript" },
    { Src: nodejs, Alt: "Node.js" },
    { Src: reactjs, Alt: "React.js" },
    { Src: android, Alt: "Android" },
    { Src: oracle, Alt: "Android" },
    { Src: postgres, Alt: "Postgres" },
    { Src: mongodb, Alt: "MongoDb" },
    { Src: mysql, Alt: "MySQL" },
    { Src: sqlserver, Alt:"SQl Server"}
];

export default ToolGroups;